"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PracticeRoomScene = void 0;
const Scene_1 = require("./Scene");
const SceneManager_1 = require("../managers/SceneManager");
const ui_1 = require("@pixi/ui");
const interfaces_1 = require("../../../shared/interfaces");
const settings_1 = require("../config/settings");
class PracticeRoomScene extends Scene_1.Scene {
    constructor(app, sceneManager, gameManager) {
        super(app, sceneManager, gameManager, settings_1.Settings.practiceColor);
        this.notified = false;
        this.subs.add(this.gameManager.room$.subscribe({
            next: (room) => __awaiter(this, void 0, void 0, function* () {
                if (!this.notified && room && room.type === interfaces_1.GameType.Practice && !this.isDeinited) {
                    this.notified = true;
                    this.gameManager.notifyReady();
                }
            })
        }));
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.gameManager.enterRoom(interfaces_1.GameType.Practice);
        });
    }
    exitScene(to, target) {
        const _super = Object.create(null, {
            exitScene: { get: () => super.exitScene }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // Find our button
            const mybutton = (_a = to.getChildByName('game' + interfaces_1.GameType.Practice, true)) !== null && _a !== void 0 ? _a : to.getChildByName('others', true);
            if (mybutton instanceof ui_1.ButtonContainer) {
                this.zIndex = SceneManager_1.Layer.Top;
                yield this.animateMask(mybutton, true);
            }
            return _super.exitScene.call(this, to);
        });
    }
    enterScene(from, target) {
        const _super = Object.create(null, {
            enterScene: { get: () => super.enterScene }
        });
        return __awaiter(this, void 0, void 0, function* () {
            // Have a cool zoom animation
            if (target instanceof ui_1.ButtonContainer) {
                yield this.animateMask(target);
            }
            return _super.enterScene.call(this, from);
        });
    }
    backTo() {
        return SceneManager_1.Scenes.Others;
    }
    get triggersStart() {
        return true;
    }
}
exports.PracticeRoomScene = PracticeRoomScene;
